import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons'
import { Font, Popover } from 'is24-corecss'
import styles from './InsertionWizardPage.module.css'

type DraftListingInfoTipProps = {
  isWebView?: boolean
}

export const DraftListingInfoTip: React.FC<DraftListingInfoTipProps> = ({ isWebView = false }) => {
  const { t } = useTranslation()
  const descriptionKey = isWebView ? 'message.draftListing.webViewDescription' : 'message.draftListing.description'
  const infoIconSize = isWebView ? 16 : 20
  const descriptionMargin = isWebView ? 'margin-bottom-l' : 'margin-bottom-s'

  return (
    <>
      <div className={`${styles.draftListingDescription} ${descriptionMargin}`} data-testid='draft-listing-description'>
        <span>{t(descriptionKey)}</span>
        <Popover.Root placement='bottom-start'>
          <Popover.Target
            className='margin-left-s display-inline-flex font-body-medium-regular align-left'
            data-testid='draft-listing-info'
          >
            <IconS24InfoCircle24 style={{ color: '#757575' }} width={infoIconSize} height={infoIconSize} />
          </Popover.Target>
          <Popover.Content>
            <div className={`display-flex gap-l padding-m ${styles.infoTooltipTextContainer}`}>
              <Font>{t('message.draftListing.infoIconText')}</Font>
            </div>
          </Popover.Content>
        </Popover.Root>
      </div>
    </>
  )
}
